/*eslint-disable*/
import React,{useState, useEffect} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/components/footerStyle.js";

const useStyles = makeStyles(styles);

export default function Footer(props) {
  const socialinfos = useSelector(state => state.socialinfos);
  const [dataInfos, setInfos] = useState({});

  useEffect(()=>{
    if(socialinfos.infos){
      setInfos(socialinfos.infos);
    }
  },[socialinfos.infos]);
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/"
                className={classes.block}
              >
                Início
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/booking-history"
                className={classes.block}
              >
                Minha Conta
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/about-us"
                className={classes.block}
              >
                Sobre nós
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/privacy-policy"
                className={classes.block}
              >
                Política de Privacidade
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/development"
                className={classes.block}
              >
                Desenvolvido por Abs Tecnologia
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                className={classes.block}
              >
                {dataInfos.email_addres}
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear() + " "} 
          <a
            href="https://new-tac-website.firebaseapp.com"
            className={aClasses}
            target="_blank"
          >
            Tac
          </a>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
